import qs from 'qs';

import { translate } from '../../../../utils/helpers';
import { DEFAULT_URL, HITS_TYPES } from '../../const';

export const getNavigationArray = (selectedTab) => {
  let navigationArr = [
    {
      title: translate('page.discover.discover'),
      url: DEFAULT_URL,
    },
  ];

  let searchObj;

  switch (selectedTab) {
    case HITS_TYPES.VIDEO: {
      searchObj = {
        title: translate('page.discover.videos'),
      };
      break;
    }
    case HITS_TYPES.PATHWAY: {
      searchObj = {
        title: translate('page.discover.pathways'),
      };
      break;
    }
    case HITS_TYPES.NEWS: {
      searchObj = {
        title: translate('page.discover.text'),
      };
      break;
    }
    case HITS_TYPES.GLOSSARY: {
      searchObj = {
        title: translate('page.discover.glossary'),
      };
      break;
    }
    default: {
      searchObj = {
        title: translate('page.discover.search'),
      };
      break;
    }
  }

  navigationArr.push(searchObj);

  return navigationArr;
};

export const createURL = (state) => `?${qs.stringify(state)}`;

export const formatSearchState = (searchState, tab) => {
  const { query, hierarchicalMenu, refinementList, menu } = searchState;
  let newRefinementList;

  if (refinementList) {
    const { searchable_type, ...refinements } = refinementList;

    newRefinementList = {
      ...refinements,
      ...(!tab && searchable_type && { searchable_type }),
    };
  }

  return {
    ...(query && { s: query }),
    ...(refinementList === Object(refinementList) &&
      !!Object.keys(refinementList).length && { refinementList: newRefinementList }),
    hierarchicalMenu,
    menu,
  };
};

export const searchStateToUrl = (location, searchState, tab) => {
  if (searchState) {
    const newSearchObj = formatSearchState(searchState, tab);

    return `${location.pathname}${createURL(newSearchObj)}`;
  } else {
    return '';
  }
};

export const urlToSearchState = (location, tab) => {
  const searchObj = qs.parse(location.search.slice(1));
  const { s, refinementList, ...filters } = searchObj as {
    s?: string;
    refinementList?: { searchable_type?: string };
  };
  return {
    ...(s && { query: s }),
    ...filters,
    refinementList: {
      ...refinementList,
      ...((refinementList?.searchable_type || tab) && {
        searchable_type: refinementList?.searchable_type || tab,
      }),
    },
  };
};
